enum FeedbackPeriodicity {
    Year = 'Y',
    Quarter = 'Q',
    Month = 'M',
    Week = 'W',
    Day = 'D',
    Free = 'F'
}

export default FeedbackPeriodicity;